import React from "react";
import { Components } from "@formio/react";
import ReactDOM from "react-dom/client";

export default class CustomHtmlComponent extends Components.components.htmlelement {
  constructor(component, options, data) {
    super(component, options, data);
  }
  

  static schema(...extend) {
    return Components.components.htmlelement.schema({
      type: "customhtml",
      label: "Custom HTML",
      key: "customHtml",
     // content: '<span>{{_.get(form.settings.data,component.key,"N/A")}}</span>',
      content:'<span style="display: block; word-wrap: break-word; font-size: 16px;"><strong>{{component.label}}</strong><br> {{_.get(form.settings.data,component.key,"N/A")}}</span>',
      input: false,
      tableView: false,
      attrs: [
        {
          attr: "",
          value: "",
        },
      ],
      refreshOnChange: false,
      customConditional: "console.log('form.settings.data', form.settings.data);",
    }, ...extend);
  }

  render() {
    return super.render();
  }

  attachReact(element) {
    const root = ReactDOM.createRoot(element);

    root.render(
      <div>
        <span dangerouslySetInnerHTML={{ __html: this.component.content }} />
      </div>
    );

    return element;
  }

  detachReact() {
    return;
  }

  static editForm() {
    return Components.components.htmlelement.editForm();
  }

  static get builderInfo() {
    return {
      title: "Custom HTML",
      icon: "code",
      group: "layout",
      weight: 10,
      schema: CustomHtmlComponent.schema(),
    };
  }
}

// Register the custom component
Components.addComponent("customhtml", CustomHtmlComponent);
